"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product = exports.defaultProductCategory = exports.defaultProductImage = exports.TProductDisplaySize = void 0;
const class_validator_1 = require("class-validator");
const cloneModelObject_1 = require("../../../../apis/spg/util/cloneModelObject");
const errorTypes_1 = require("../../../../apis/spg/helpers/errorTypes");
var TProductDisplaySize;
(function (TProductDisplaySize) {
    TProductDisplaySize["Large"] = "large";
    TProductDisplaySize["Small"] = "small";
})(TProductDisplaySize = exports.TProductDisplaySize || (exports.TProductDisplaySize = {}));
// TODO upload the placeholder image to where the other product images are
// and update this link
exports.defaultProductImage = "https://via.placeholder.com/600x400?text=Image+Not+Found";
/**
 * Any product that is missing its category info
 * (which might not yet be configured in CMS)
 * will fall into this default category which
 * has a large enough priority value to ensure
 * that it is always displayed last.
 */
exports.defaultProductCategory = {
    name: "other",
    label: "Other",
    priority: 999,
    displaySize: TProductDisplaySize.Large
};
/**
 * Base Product class, must be extended to either StockedProduct or
 * ProductBlueprint for use.
 */
class Product {
    constructor() {
        this.imageUrl = exports.defaultProductImage;
    }
    filterSensitiveData() {
        const clone = (0, cloneModelObject_1.cloneModelObject)(this);
        return clone;
    }
    serialize() {
        return {
            productId: this.productId,
            retailLocationId: this.retailLocationId,
            title: this.title,
            description: this.description,
            imageUrl: this.imageUrl,
            retailPrice: this.retailPrice,
            dietaryInfo: this.dietaryInfo,
            productPriority: this.productPriority
        };
    }
    async validate() {
        const validated = await (0, class_validator_1.validate)(this);
        if (validated.length > 0) {
            throw new errorTypes_1.ValidationError(validated);
        }
        return true;
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], Product.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], Product.prototype, "retailLocationId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], Product.prototype, "title", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], Product.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)()
], Product.prototype, "imageUrl", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsNotEmpty)()
], Product.prototype, "retailPrice", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)()
], Product.prototype, "dietaryInfo", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)()
], Product.prototype, "productPriority", void 0);
exports.Product = Product;
//# sourceMappingURL=Product.js.map